/**
 * AlertBar
 */
import React from 'react';
import Icon from '../Icon';
import { Grid, Cell } from 'ui-component-library/base';
import { useCookie } from 'ui-component-library/hooks/useCookie';
/** Main description for this component. */
var AlertBar = function (_a) {
    var children = _a.children, isCloseable = _a.isCloseable, closeButtonLabel = _a.closeButtonLabel, hideIfAlertbarSet = _a.hideIfAlertbarSet, alertbarName = _a.alertbarName;
    var _b = useCookie(alertbarName, 'false'), closedAlertbar = _b[0], setClosedAlertbar = _b[1];
    if (closedAlertbar === 'true' && hideIfAlertbarSet) {
        return null;
    }
    return (React.createElement("div", { "data-cid": "Alertbar", className: "bg-black p-4 flex items-start md:justify-between" },
        React.createElement("div", { className: "alert-bar" },
            React.createElement(Icon, { icon: "warning", color: "black", "aria-hidden": "true", size: 1.25 }),
            React.createElement(Grid, { padding: false },
                React.createElement(Cell, { span: 12 },
                    React.createElement("div", { className: "alert-bar-text" }, children)))),
        isCloseable && (React.createElement("button", { "aria-label": closeButtonLabel, type: "button", onClick: function () {
                setClosedAlertbar('true', {
                    days: null,
                    path: '/',
                });
            } },
            React.createElement(Icon, { icon: "close", color: "white", "aria-hidden": "true", size: 1.25 })))));
};
export default AlertBar;
